// @flow

export { GlobalStyle } from './global-style';
